import { useRef } from "react"
import { Checkbox } from "@planningcenter/doxy-web"
import {
  ChurchCenterCustomFieldApiRecordWithRelationships,
  DeleteFieldDataRecord,
  UpdateCustomFieldAttributes,
} from "source/myChurchCenter/Profile/types"
import { Icon } from "source/shared/components"

export function Checkboxes({
  customField,
  deleteFieldDataRecord,
  updateAttributes,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
  deleteFieldDataRecord: DeleteFieldDataRecord
  updateAttributes: UpdateCustomFieldAttributes
}) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const options = customField.relationships.field_options?.data
  const fieldValue =
    customField.relationships.field_data?.data[0]?.attributes?.value
  const {
    attributes: { editing_rules: editingRules },
  } = customField

  const valueRef = useRef(fieldValue)

  const disabled =
    editingRules === "view" ||
    !!(editingRules === "add_if_blank" && valueRef.current)

  const findMatchingFieldDataRecord = (
    customField: ChurchCenterCustomFieldApiRecordWithRelationships,
    label: string,
  ) => {
    return customField.relationships.field_data?.data.find(
      (fd) => fd.attributes.value === label,
    )
  }

  return (
    <div key={customField.id}>
      <div className="d-f">
        <label htmlFor={fieldName}>{fieldName}</label>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      {options?.map((option) => (
        <Checkbox
          disabled={disabled}
          key={`custom-field-${customField.id}-checkbox-${option.id}`}
          label={option.attributes.label}
          id={`checkbox-${option.id}`}
          onChange={(e) => {
            const matchingDataRecord = findMatchingFieldDataRecord(
              customField,
              option.attributes.label,
            )
            if (e.target.checked) {
              updateAttributes({
                customField,
                record: matchingDataRecord || null,
                attributes: {
                  value: option.attributes.label,
                  field_option_id: option.id,
                },
              })
            } else {
              if (matchingDataRecord) {
                deleteFieldDataRecord({
                  customField,
                  fieldData: matchingDataRecord,
                })
              }
            }
          }}
          checked={
            !!findMatchingFieldDataRecord(customField, option.attributes.label)
          }
        />
      ))}
    </div>
  )
}
